import { Typography } from '@mui/material'
import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useThemeMode } from '../../../theme'

const getRemainingSeconds = (deadlineUtc) => {
  const deadlineMs = Date.parse(deadlineUtc)
  if (Number.isNaN(deadlineMs)) {
    return 0
  }
  return Math.max(0, Math.floor((deadlineMs - Date.now()) / 1000))
}

const toHHMMSS = (remainingSeconds) => {
  const hours = Math.floor(remainingSeconds / 3600)
  const minutes = Math.floor((remainingSeconds % 3600) / 60)
  const seconds = remainingSeconds % 60
  const hh = String(hours).padStart(2, '0')
  const mm = String(minutes).padStart(2, '0')
  const ss = String(seconds).padStart(2, '0')
  return `${hh}:${mm}:${ss}`
}

export const DeadlineCountdown = (props) => {
  const { deadlineUtc } = props
  const { palette } = useThemeMode()
  const { t } = useTranslation()
  const [remainingSeconds, setRemainingSeconds] = useState(() => getRemainingSeconds(deadlineUtc))

  useEffect(() => {
    const initialRemaining = getRemainingSeconds(deadlineUtc)
    setRemainingSeconds(initialRemaining)

    if (initialRemaining <= 0) {
      return
    }

    const id = setInterval(() => {
      const nextRemaining = getRemainingSeconds(deadlineUtc)
      if (nextRemaining <= 0) {
        clearInterval(id)
        setRemainingSeconds(0)
        return
      }

      setRemainingSeconds(nextRemaining)
    }, 1000)

    return () => {
      clearInterval(id)
    }
  }, [deadlineUtc])

  const label = useMemo(() => {
    if (remainingSeconds <= 0) {
      return t('deadline-ended')
    }
    return toHHMMSS(remainingSeconds)
  }, [remainingSeconds, t])

  return (
    <Typography
      fontSize='0.75rem'
      fontWeight={700}
      color={palette.headerColor}
      textAlign='right'
      width='100%'
      display='block'
      mb='6px'
    >
      {label}
    </Typography>
  )
}
